import { ACTION_REWARD_FRIENDS, ACTION_REWARD_FRIENDS_ERROR, ACTION_REWARD_FRIENDS_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    data: undefined
}


export const getRewardFriendsReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_REWARD_FRIENDS:
            return { ...state, isLoading: true, erro_msg: undefined }
        case ACTION_REWARD_FRIENDS_SUCCESS:
            return { ...state, isLoading: false, erro_msg: undefined, data: action.payload.data }
        case ACTION_REWARD_FRIENDS_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}